'use client';
import { useEffect, useState } from 'react';

const useWindowSize = () => {
  const isClient = typeof window === 'object';

  const [width, setWidth] = useState(isClient ? window.innerWidth : 0);
  const [height, setHeight] = useState(isClient ? window.innerHeight : 0);

  useEffect(() => {
    if (!isClient) {
      return;
    }

    const handleWindowResize = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleWindowResize);

    return () => window.removeEventListener('resize', handleWindowResize);
  }, [isClient]);

  const isMobile = isClient ? width <= 480 : false;
  const isTablet = isClient ? width <= 834 : false;

  return { isMobile, isTablet, width, height };
};

export default useWindowSize;
